"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapFromObject = exports.b64DecodeUnicode = exports.b64EncodeUnicode = exports.deepFreeze = exports.formatUUID = exports.getDeviceUUID = exports.isProtocol2 = exports.getUserAgent = exports.convertMillisecondsToMinutesAndSeconds = exports.getRandomValueCrypto = exports.getRandomNumberCharacters = exports.convertObjectKeysToLowerCase = exports.mergeDeep = exports.mergeDeepWithDefault = exports.isBooleanFromString = exports.isValidDate = exports.isArray = exports.isBoolean = exports.isString = exports.isObject = exports.compareProp = exports.isEmpty = exports.removeLastSlash = exports.promiseTimeout = void 0;
const fingerprintjs_1 = __importDefault(require("@fingerprintjs/fingerprintjs"));
const logger_1 = require("./logger");
const messages_1 = require("./messages");
/**
 * Is a promise with deadline, util for communication and others for non-eternal waiting
 *
 * based on: stackoverflow questions/32461271/nodejs-timeout-a-promise-if-failed-to-complete-in-time
 * @param resolver
 * @param ms
 * @returns {Promise<T>}
 */
const promiseTimeout = (resolver, ms) => {
    return new Promise(function (resolve, reject) {
        // @ts-expect-error TODO solve
        const timer = setTimeout(function () {
            cancelTimer();
            reject(messages_1.CoreHelperMessages.CORE_PROMISE_TIMEOUT_REACHED);
        }, ms);
        const cancelTimer = () => {
            // @ts-expect-error TODO resolve without comment ts-expect
            clearTimeout(timer);
        };
        // Set up the real work
        resolver(value => {
            cancelTimer();
            resolve(value);
        }, error => {
            cancelTimer();
            reject(error);
        });
    });
};
exports.promiseTimeout = promiseTimeout;
/**
 * it is util for end of urls
 * @param value
 */
const removeLastSlash = (value) => {
    if (!value) {
        return value;
    }
    return value.replace(/\/$/g, '');
};
exports.removeLastSlash = removeLastSlash;
/**
 * detect if it is a `{}`
 * @param obj
 */
const isEmpty = (obj) => {
    // return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
    let found = false;
    for (const key in obj) {
        found = true;
    }
    return !found;
};
exports.isEmpty = isEmpty;
const compareProp = (field, obj1, obj2) => {
    return obj1 && obj2 && obj1[field] === obj2[field];
};
exports.compareProp = compareProp;
/**
 * Simple object check.
 * @param obj
 * @returns {boolean}
 */
const isObject = (obj) => {
    return obj && typeof obj === 'object' && !Array.isArray(obj);
};
exports.isObject = isObject;
const isString = (val) => {
    return typeof val === 'string';
};
exports.isString = isString;
const isBoolean = (val) => {
    return typeof val === 'boolean';
};
exports.isBoolean = isBoolean;
const isArray = (data) => {
    return data && Array.isArray(data);
};
exports.isArray = isArray;
const isValidDate = (d) => {
    // @ts-expect-error not validation for isNaN a date
    return d instanceof Date && !isNaN(d);
};
exports.isValidDate = isValidDate;
const isBooleanFromString = (val) => {
    if (!val || !(0, exports.isString)(val)) {
        return undefined;
    }
    val = val.toLowerCase();
    return val === 'true' || val === 'false';
};
exports.isBooleanFromString = isBooleanFromString;
const mergeDeepWithDefault = (target, ...sources) => {
    return (0, exports.mergeDeep)(target, ...sources);
};
exports.mergeDeepWithDefault = mergeDeepWithDefault;
const mergeDeep = (...sources) => {
    return sources.reduce((sourceAccum, newSource) => {
        return _mergeDeep(sourceAccum, newSource);
    });
};
exports.mergeDeep = mergeDeep;
/* istanbul ignore next */
const _mergeDeep = (target, source) => {
    const output = Object.assign({}, target);
    if ((0, exports.isObject)(target) && (0, exports.isObject)(source)) {
        // @ts-expect-error code copied from stackoverflow
        Object.keys(source).forEach(key => {
            // @ts-expect-error code copied from stackoverflow
            if ((0, exports.isObject)(source[key])) {
                if (!target[key]) {
                    Object.assign(output, {
                        // @ts-expect-error code copied from stackoverflow
                        [key]: source[key],
                    });
                }
                else {
                    // @ts-expect-error code copied from stackoverflow
                    output[key] = (0, exports.mergeDeep)(target[key], source[key]);
                }
            }
            else {
                Object.assign(output, {
                    // @ts-expect-error code copied from stackoverflow
                    [key]: source[key],
                });
            }
        });
    }
    return output;
};
const convertObjectKeysToLowerCase = (keys) => {
    const keysLowerCase = {};
    Object.keys(keys).forEach(key => {
        keysLowerCase[key.toLowerCase()] = keys[key];
    });
    return keysLowerCase;
};
exports.convertObjectKeysToLowerCase = convertObjectKeysToLowerCase;
const getRandomNumberCharacters = (characters = 10) => {
    return ((0, exports.getRandomValueCrypto)() * 10).toString().replace('.', '').substring(0, characters);
};
exports.getRandomNumberCharacters = getRandomNumberCharacters;
/**
 * getRandomValueCrypto, this return a valid and secure value for sonar
 *
 * from: https://stackoverflow.com/questions/18230217/javascript-generate-a-random-number-within-a-range-using-crypto-getrandomvalues/62792582#62792582
 */
const getRandomValueCrypto = () => {
    const randomBuffer = new Uint32Array(1);
    window.crypto.getRandomValues(randomBuffer);
    return randomBuffer[0] / (0xffffffff + 1);
};
exports.getRandomValueCrypto = getRandomValueCrypto;
const convertMillisecondsToMinutesAndSeconds = (expiresInMs) => {
    const expiresIn = new Date(expiresInMs);
    const expiresInSeconds = '0' + expiresIn.getSeconds();
    return `${expiresIn.getMinutes()}:${expiresInSeconds.substring(expiresInSeconds.length - 2)}`;
};
exports.convertMillisecondsToMinutesAndSeconds = convertMillisecondsToMinutesAndSeconds;
const getUserAgent = () => {
    return window.navigator.userAgent;
};
exports.getUserAgent = getUserAgent;
const isProtocol2 = () => 
// NOTE: Activate when the protocol is ready
// getUserAgent().includes('gs.protocol/2.0');
false;
exports.isProtocol2 = isProtocol2;
/* istanbul ignore next by external library */
const getDeviceUUID = () => __awaiter(void 0, void 0, void 0, function* () {
    // only on demand:
    const fpPromise = fingerprintjs_1.default.load();
    const fp = yield fpPromise;
    const result = yield fp.get();
    logger_1.Log.info('[utils.getDeviceUUID]', result.visitorId);
    return (0, exports.formatUUID)(result.visitorId);
});
exports.getDeviceUUID = getDeviceUUID;
const formatUUID = (hash) => {
    if (hash.length !== 32) {
        throw Error(messages_1.CoreHelperMessages.CORE_UUID_INVALID);
    }
    const splitArr = hash.split('');
    const formatPositions = [8, 13, 18, 23];
    formatPositions.forEach(val => splitArr.splice(val, 0, '-'));
    return splitArr.join('');
};
exports.formatUUID = formatUUID;
/** https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/freeze */
const deepFreeze = (object) => {
    // Retrieve the property names defined on object
    const propNames = Object.getOwnPropertyNames(object);
    // Freeze properties before freezing self
    for (const name of propNames) {
        const value = object[name];
        if (value && typeof value === 'object') {
            (0, exports.deepFreeze)(value);
        }
    }
    return Object.freeze(object);
};
exports.deepFreeze = deepFreeze;
const b64EncodeUnicode = (str) => {
    return window.btoa(window.encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (_match, p1) {
        return String.fromCharCode(parseInt(p1, 16));
    }));
};
exports.b64EncodeUnicode = b64EncodeUnicode;
const b64DecodeUnicode = (str) => {
    return decodeURIComponent(Array.prototype.map
        .call(window.atob(str), function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(''));
};
exports.b64DecodeUnicode = b64DecodeUnicode;
const mapFromObject = (obj) => {
    return new Map(Object.entries(obj));
};
exports.mapFromObject = mapFromObject;
//# sourceMappingURL=utils.js.map